import React, { useState, useEffect } from "react";
import { Avatar, AvatarGroup, Tooltip, Menu, MenuItem, Typography, Divider } from "@mui/material";
import { s3baseUrl } from "src/config";
import { useAppContext } from "src/hooks";
import { capitalize } from "lodash";
import moment from "moment";
import { memo } from "react";

function ChatSeenAvatar({
    // handleAddNewChat, 
    index,
}) {
    const { dispatch_get_user_profile, chatData, } = useAppContext();

    const [anchorEl, setAnchorEl] = useState(null);
    const userProfile = dispatch_get_user_profile();
    const [filteredUser, setFilteredUser] = useState(filteredUserBySeenMessage(index));
    const [isShowAvatarGroup, setIsShowAvatarGroup] =
        useState(chatData?.member_user?.some(user =>
            user.unread_messages_count == index && userProfile.user_id !== user.user_id
        ));
    const [totalUsersRead, setTotalUsersRead] = useState([]);


    function filteredUserBySeenMessage(value) {
        return chatData?.member_user?.filter(user =>
            user.unread_messages_count === value && userProfile.user_id !== user.user_id
        );
    }
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setTotalUsersRead((prev) => {
            let newUsers = [];
            for (let i = 0; i <= index; i++) {
                newUsers.push(...filteredUserBySeenMessage(i));
            }
            return [...new Set([...newUsers])];
            // return [...newUsers];
        });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setIsShowAvatarGroup(chatData?.member_user?.some(user =>
            user.unread_messages_count == index && userProfile.user_id !== user.user_id
        ));
        setFilteredUser(filteredUserBySeenMessage(index));
    }, [chatData, index]);

    return (
        <>
            {isShowAvatarGroup && (
                <AvatarGroup
                    max={4}
                    spacing={1}
                    className="my-2 chat-profile-avatar"
                    sx={{
                        "& .MuiAvatar-root": {
                            width: 16,
                            height: 16,
                            fontSize: 9,
                        },
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                    }}
                >
                    {filteredUser.map(user => (
                        <Tooltip
                            key={user.user_id}
                            arrow
                            title={`${capitalize(user.first_name)} ${capitalize(user.last_name)}`}
                            disableInteractive
                        >
                            <Avatar src={s3baseUrl + user.image}>
                                {capitalize(user.first_name?.charAt(0))}
                            </Avatar>
                        </Tooltip>
                    ))}
                </AvatarGroup>
            )}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                disableAutoFocusItem
                disablePortal
                disableEnforceFocus
                keepMounted={false}
            >
                <Typography
                    variant="body1"
                    fontWeight="600"
                    noWrap
                    className="m-2 ms-3"
                >
                    Read By {totalUsersRead.length}
                </Typography>
                <Divider />
                <div className="read-by-container">
                    {totalUsersRead.map(user => (
                        <MenuItem key={user.user_id} onClick={(e) => {
                            console.log(filteredUser.length);
                            // if (filteredUser.length > 1) {
                            //     handleAddNewChat(user);
                            // }
                            console.log(user, "Selected user");
                            setAnchorEl(null);
                        }}>
                            <Avatar
                                src={s3baseUrl + user.image}
                                sx={{ width: 26, height: 26, marginRight: 1 }}
                            />
                            <div className="dialog-avatar">
                                <Typography
                                    variant="body2"
                                    fontWeight="600"
                                    noWrap
                                    className="me-2"
                                >
                                    {capitalize(user.first_name)} {capitalize(user.last_name)}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    fontWeight="400"
                                    fontSize="12px"
                                    noWrap
                                    className="me-2"
                                >
                                    {user.last_seen_time ? moment(user.last_seen_time).format("LLL") : " "}
                                </Typography>
                            </div>
                        </MenuItem>
                    ))}
                </div>
            </Menu>
        </>
    );
}
export default memo(ChatSeenAvatar);